import React, { useEffect, useRef, useState } from 'react';
import { Box, Button, Grid, Paper, Typography, IconButton, Modal, Alert, TextField } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import CancelIcon from '@mui/icons-material/Cancel';
import MapIcon from '@mui/icons-material/Map';
import CloseIcon from '@mui/icons-material/Close';
import { useNavigate } from 'react-router-dom';
import useServices from '../../services/useServices';
import moment from 'moment';
import { getSessionData } from '../../utils/utils';
import TrackingComponent from '../../components/TrackingComponent';
import RouteMap from '../../components/RouteMap';
import useMediaQuery from '@mui/material/useMediaQuery';

const CALL_STATUS_MAP = {
  "Unassigned": 0,
  "Assigned": 1,
  "Accepted": 2,
  "Enroute": 3,
  "Arrived": 4,
  "Hooked": 5,
  "Dropped": 6,
  "Cleared": 7
};

const PHASE_MAP = {
  "enroute_to_pickup": [1, 2, 3],
  "enroute_to_dropoff": [4, 5, 6],
  "pickup_to_drop": [0]
};

const steps = [
  {
    label: "Request Received",
    status: "requestTime",
    class: "requested",
    description: null
  },
  {
    label: "Driver Assigned",
    status: "acceptedTime",
    class: "accepted",
    description: null
  },
  {
    label: "Driver Enroute",
    status: "enrouteTime",
    class: "onroute",
    description: null
  },
  {
    label: "Driver Arrived",
    status: "arrivedTime",
    class: "arrived",
    description: null
  }
];

const alertStyles = {
  position: 'fixed',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  zIndex: 1000,
  width: '300px',
  textAlign: 'center'
};

const TrackOrder = () => {
  const navigate = useNavigate();
  const { get, put } = useServices();
  const [showTrackingDetailsID, setShowTrackingDetailsID] = useState();
  const [cancelReason, setCancelReason] = useState("");
  const [isOpenCancelWindow, setIsOpenCancelWindow] = useState(false);
  const [requestDetails, setRequestDetails] = useState({});
  const [initialRespData, setInitialRespData] = useState([]);
  const [trackingData, setTrackingData] = useState(JSON.parse(JSON.stringify(steps)));
  const [isLoading, setIsLoading] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("success");
  const [anchorEl, setAnchorEl] = useState(null);
  const cancelBtnRef = useRef(null);
  const [invoiceToCancel, setInvoiceToCancel] = useState("");
  const ourRequest = useRef(null);
  const [modalStyle, setModalStyle] = useState({});
  const [openRouteMap, setRouteMap] = useState(false);
  const [mapType, setMapType] = useState('enroute');
  const [routeCoordinates, setRouteCoordinates] = useState([]);
  const [openTrackingModal, setOpenTrackingModal] = useState(false);
  const isMobile = useMediaQuery('(max-width:600px)');

  const gotoHome = () => { navigate("/newrequest") };
  const handleOpen = () => setIsOpenCancelWindow(true);
  const handleClose = () => setIsOpenCancelWindow(false);
  const serviceOrders = getSessionData('serviceOrders');
  const serviceRequestNumbers = serviceOrders ? JSON.parse(serviceOrders) : [];
  const clearFromTrack = () => { window.location.reload() };
  const handlePopoverOpen = () => { if (!cancelReason) { setAnchorEl(cancelBtnRef.current); } };
  const handlePopoverClose = () => { setAnchorEl(null); };
  const open = Boolean(anchorEl);
  const [deliveryPhase, setDeliveryPhase] = useState('enroute_to_pickup');

  const showTrackingDetails = (id) => {
    setTrackingData(JSON.parse(JSON.stringify(steps)));
    if (id === showTrackingDetailsID) {
      setShowTrackingDetailsID(null);
      setRequestDetails({});
      setIsLoading(false);
      setOpenTrackingModal(false);
    } else {
      setIsLoading(true);
      setRequestDetails(initialRespData[id]);
      setShowTrackingDetailsID(id);
      setOpenTrackingModal(true);
    }
  };

  const setTrackingDetailsData = () => {
    if (requestDetails.callStatus !== 'Cancel') {
      trackingData.map(item => {
        const dateTime = requestDetails[item.status];
        item.description = dateTime ? moment(dateTime).format('HH:mm:ss MM/DD/YYYY') : dateTime;
        return item;
      });
      setTrackingData(JSON.parse(JSON.stringify(trackingData)));
    }
    setIsLoading(false);
  };

  const fetchInitialData = async () => {
    try {
      const userID = getSessionData("userID");
      const ordersData = await get(`newservicecall/directCall/` + userID);
      const respData = ordersData.data?.resp || [];
      const newDataArray = [];
      newDataArray.push(...(respData || []));
      setInitialRespData(newDataArray);
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  useEffect(() => {
    const handlePopState = (event) => {
      // Check if the modal is open
      if (openTrackingModal) {
        // Close the modal
        setOpenTrackingModal(false);
      } else {
        // If the modal is not open, allow the navigation
        navigate(-1);
      }
    };
  
    window.addEventListener('popstate', handlePopState);
  
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [openTrackingModal]);
  
  // Push a new state to the history only when opening the modal
  useEffect(() => {
    if (openTrackingModal) {
      window.history.pushState({ openTrackingModal: true }, '');
    }
  }, [openTrackingModal]);
  
  

  const cancelInvoice = async () => {
    try {
      const userID = getSessionData("userID");
      if (userID) {
        const requestBody = {
          "invoiceId": invoiceToCancel,
          "callStatus": "Cancel",
          "reason": cancelReason,
          statusValue: "Edit"
        };
        const res = await put(`newservicecall/directCall`, requestBody);
        handleClose();
        if (res.data.statusCode === 200) {
          setAlertMessage("Call has been cancelled successfully!");
          setAlertSeverity("success");
          fetchInitialData();
        } else {
          setAlertMessage("Failed to cancel the call!");
          setAlertSeverity("error");
        }
        setCancelReason("");
        setShowAlert(true);
        setTimeout(() => {
          setShowAlert(false);
        }, 1000);
      } else {
        throw 'user not valid';
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchInitialData();
  }, []);

  useEffect(() => {
    const userID = getSessionData("userID");
    if (!userID) {
      // navigate("/unauthorizedUser")
    }
  }, []);

  useEffect(() => {
    setTrackingDetailsData();
  }, [requestDetails]);

  useEffect(() => {
    const updateModalStyle = () => {
      const baseStyles = {
        position: 'absolute',
        overflow: 'auto',
        backgroundColor: '#FFF',
        boxSizing: 'border-box',
        border: '4px solid #f21c0c',
      };

      if (window.innerWidth <= 768) {
        setModalStyle({
          ...baseStyles,
          top: '5%',
          left: '5%',
          width: '90%',
          height: '90%',
        });
      } else {
        setModalStyle({
          ...baseStyles,
          top: '10%',
          left: '10%',
          width: '80%',
          height: '80%',
        });
      }
    };

    updateModalStyle();
    window.addEventListener('resize', updateModalStyle);
    return () => {
      window.removeEventListener('resize', updateModalStyle);
    };
  }, []);

  const handleRouteMapOpen = (index) => {
    const selectedItem = initialRespData[index];
    setRouteCoordinates([]);
    const parseCoordinates = (coordStr) => {
      if (!coordStr) return null;
      const [lat, lng] = coordStr.split(',').map(parseFloat);
      if (!lat || !lng) return null;
      return { lat, lng };
    };
    const driverCurrentGps = parseCoordinates(selectedItem.driverCurrentGps);
    const pickupCoordinate = parseCoordinates(selectedItem.pickupCoordinate);
    const dropoffCoordinate = parseCoordinates(selectedItem.dropoffCoordinate);
    const data = [
      {
        addressType: 'Pickup',
        address: selectedItem.pickup || '',
        coordinates: pickupCoordinate,
        eta: selectedItem.etaPick
      },
      {
        addressType: 'Truck',
        address: selectedItem.truckCurrentAddress || '',
        coordinates: driverCurrentGps
      },
      {
        addressType: 'Drop',
        address: selectedItem.dropoff || '',
        coordinates: dropoffCoordinate,
        eta: selectedItem.etaDrop
      }
    ];
    setRouteCoordinates(data);
    setRouteMap(true);
  };

  return (
    <>
      <Box sx={{ flexGrow: 1, paddingLeft: 1, paddingRight: 1, paddingTop: 1, backgroundColor: "#f5f5f5" }}>
        <Grid container spacing={1}>
          <Grid item xs={12} container justifyContent="space-between" alignItems="center">
            <Button variant="contained" color="success" onClick={gotoHome}>NEW REQUEST</Button>
            <Button variant="contained" onClick={clearFromTrack} color="primary">Refresh</Button>
          </Grid>
          <Box sx={{ overflowX: 'auto', width: '100%' }}>
            <Grid container item xs={12} alignItems="center" justifyContent="center" style={{ minWidth: 600 }}>
              <Grid item xs={2} container justifyContent="center">
                <Typography variant="body2" component="div" style={{ fontWeight: 'bold' }}>Invoice</Typography>
              </Grid>
              <Grid item xs={4} container justifyContent="center">
                <Typography variant="body2" component="div" style={{ fontWeight: 'bold', textAlign: 'center' }}>Time Elapsed</Typography>
              </Grid>
              <Grid item xs={3} container justifyContent="center">
                <Typography variant="body2" component="div" style={{ fontWeight: 'bold', textAlign: 'center' }}>ETA</Typography>
              </Grid>
              <Grid item xs={3} container justifyContent="center">
                <Typography variant="body2" component="div" style={{ fontWeight: 'bold', textAlign: 'right' }}>Map</Typography>
              </Grid>
            </Grid>
            {showAlert &&
              <div style={alertStyles}>
                <Alert severity={alertSeverity}>{alertMessage}</Alert>
              </div>
            }
            {(Array.isArray(initialRespData) ? initialRespData : []).map((item, index) => (
              <Grid item xs={12} key={index}>
                {!item.hookedTime && (
                  <>
                    <Paper style={{ position: 'relative', minWidth: 600 }}>
                      {item.flatbedNeeded &&
                        <div className="flatbed-section" style={{
                          top: '0',
                          left: '0',
                          width: '100%',
                          backgroundColor: '#ff7043',
                          color: '#fff',
                          textAlign: 'center',
                          borderRadius: '30px 30px 0 0',
                          fontSize: '14px',
                          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)'
                        }}>
                          <strong>Flatbed Requested</strong>
                        </div>
                      }
                      <Grid container item xs={12} alignItems="center" justifyContent="center">
                        <Grid item xs={2} container justifyContent="center" onClick={() => showTrackingDetails(index)}>
                          <Typography variant="body2" style={{ wordBreak: 'break-all' }}>#{item.invoiceId}</Typography>
                        </Grid>
                        <Grid item xs={4} container justifyContent="center" onClick={() => showTrackingDetails(index)}>
                          <Typography variant="body2" style={{ textAlign: 'center' }}>{item.elapsedTime?.split(':')[0] || " __"} min {item.elapsedTime?.split(':')[1] || " __"} sec</Typography>
                        </Grid>
                        <Grid item xs={3} container justifyContent="center">
                          <Typography variant="body2" style={{ textAlign: 'center' }}>{item.etaPick}</Typography>
                        </Grid>
                        <Grid container justifyContent="center" item xs={3}>
                          <Grid container justifyContent="flex-end">
                            {item.deviceId === getSessionData("uniqueDeviceId") &&
                              <IconButton
                                style={{ padding: 0 }}
                                onClick={() => {
                                  handleOpen();
                                  setInvoiceToCancel(item.invoiceId);
                                }}>
                                <CancelIcon />
                              </IconButton>
                            }
                            <IconButton style={{ padding: 0 }} onClick={() => handleRouteMapOpen(index)}>
                              <MapIcon />
                            </IconButton>
                          </Grid>
                        </Grid>
                      </Grid>
                      
                      {/* Pickup address sub-line */}
                      {item.pickup && (
                        <Grid container item xs={12} style={{ 
                          borderTop: '1px dashed #ccc',
                          backgroundColor: '#f8f8f8',
                          padding: '4px 8px',
                          marginTop: '4px'
                        }}>
                          <Typography 
                            variant="caption" 
                            style={{ 
                              fontStyle: 'italic',
                              color: '#555',
                              fontSize: '0.85rem',
                              textOverflow: 'ellipsis',
                              overflow: 'hidden',
                              width: '100%'
                            }}
                          >
                            <span style={{ fontWeight: 'bold' }}>Pickup:</span> {item.pickup}
                          </Typography>
                        </Grid>
                      )}
                    </Paper>
                  </>
                )}
              </Grid>
            ))}
          </Box>
        </Grid>
        <style jsx>{`
          @media (max-width: 600px) {
            .header-grid {
              flex-direction: column;
            }
            .header-item {
              text-align: center !important;
            }
          }
        `}</style>
      </Box>
      <Modal
        open={isOpenCancelWindow}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '90%',
          maxWidth: 400,
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
        }}>
          <h2 id="modal-modal-title">Cancel Reason</h2>
          <TextField
            id="outlined-basic"
            label="Reason"
            variant="outlined"
            fullWidth
            value={cancelReason}
            onChange={(e) => setCancelReason(e.target.value)}
            style={{ marginBottom: '20px' }}
          />
          {!cancelReason && (
            <Typography variant="body2" color="error">
              Please provide a reason for cancellation.
            </Typography>
          )}
          <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '10px' }}>
            <Button
              variant="contained"
              color="secondary"
              onClick={() => { handleClose(); setCancelReason(""); }}
              style={{ marginRight: '10px' }}
            >
              Back
            </Button>
            <Button
              variant="contained"
              color="primary"
              disabled={!cancelReason}
              onClick={() => {
                if (cancelReason) {
                  console.log("Performing action with reason:", cancelReason);
                  cancelInvoice();
                }
              }}
            >
              Cancel
            </Button>
          </div>
        </Box>
      </Modal>
      <Modal
        open={openRouteMap}
        onClose={() => setRouteMap(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div style={modalStyle}>
          <div style={{ overflow: 'auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px', backgroundColor: '#333', padding: '10px' }}>
            <h2 style={{ margin: '0', color: '#fff', fontSize: '24px', textAlign: 'center', flexGrow: 1 }}>
              ARS Enroute Map
            </h2>
            <IconButton
              onClick={() => setRouteMap(false)}
              style={{ color: '#f21c0c' }}
            >
              <CloseIcon />
            </IconButton>
          </div>
          <RouteMap mapType={mapType} data={routeCoordinates} />
        </div>
      </Modal>
      <Modal
        open={openTrackingModal}
        onClose={() => setOpenTrackingModal(false)}
      >
        <div style={modalStyle}>
          <div style={{ overflow: 'auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px', backgroundColor: '#f21c0c', padding: '10px' }}>
            <h2 style={{ margin: '0', color: '#fff', fontSize: '24px', textAlign: 'center', flexGrow: 1 }}>
              ARS Invoice
            </h2>
            <IconButton
              onClick={() => setOpenTrackingModal(false)}
              style={{ color: '#fff' }}
            >
              <CloseIcon />
            </IconButton>
          </div>
          {requestDetails && (
            <TrackingComponent
              invoiceId={requestDetails.invoiceId}
              clearFromTrack={clearFromTrack}
              hookedTime={requestDetails.hookedTime}
              onRevertCall={() => {
                fetchInitialData();
                setShowTrackingDetailsID(null);
                setOpenTrackingModal(false);
              }}
              cancelReason={(requestDetails.callStatus === 'Cancel') ? requestDetails.reason : ''}
              invoiceStatus={requestDetails.callStatus}
              steps={trackingData}
              isLoading={isLoading}
              data={requestDetails}
            />
          )}
        </div>
      </Modal>
    </>
  );
}

export default TrackOrder;
